<div class="notes item-wrapper">
   <mat-form-field style="flex-grow: 1;">
      <mat-label>Note</mat-label>
      <textarea matInput cdkTextareaAutosize [formControl]="control" required></textarea>
   </mat-form-field>
</div>
